import React from 'react';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import lodash from 'lodash';
import { BOREHOLE_INSTALLATION_CABLE_SIZE } from '../../../appConstants';

interface ICableSizeSelectorProps {
    value : number;

    onChange : (value : number) => void;
}

interface ICableSizeSelectorState {}

export default class CableSizeSelector extends React.Component<ICableSizeSelectorProps, ICableSizeSelectorState> {
    constructor(props : ICableSizeSelectorProps) {
        super(props);
        this.state = {};
    }

    private readonly onChange = (event : React.ChangeEvent<{
        name ?: string | undefined;
        value : unknown;
    }>) => {
        this.props.onChange(Number(event.target.value));
    };

    public readonly render = () => {
        const { value } = this.props;

        return (<React.Fragment>
            <div className={'flx1 ais p5 mb10 pr20'}>
                <FormControl margin='normal' fullWidth>
                    <InputLabel shrink={!!value} htmlFor='cableSize'>Cable Size</InputLabel>
                    <Select
                        fullWidth
                        id='cableSize'
                        value={!value ? '' : value}
                        onChange={this.onChange}>
                        <MenuItem value=''>
                            <em>None</em>
                        </MenuItem>
                        {
                            lodash.map(BOREHOLE_INSTALLATION_CABLE_SIZE, n => (
                                <MenuItem key={`${n}_cableSize`} value={n}>
                                    {n}
                                </MenuItem>
                            ))
                        }
                    </Select>
                </FormControl>
            </div>
        </React.Fragment>);
    };
}
